export const shape = {
  borderRadius: 10,
};


